<!-- App.vue -->
<template>
  <CartWidget />
</template>

<script setup lang="ts">
import CartWidget from '@/components/CartWidget.vue'
</script>
